import { createReactComponent } from '@tabler/icons-react';

// Tabler's `refresh` mirrored so its arrows run clockwise. The original points
// counter-clockwise, which fights the clockwise `spin` animation on sync
// buttons (FontAwesome's arrows-rotate, which this replaces, was clockwise).
const IconRefreshClockwise = createReactComponent('outline', 'refresh-clockwise', 'RefreshClockwise', [
    ['path', { d: 'M4 11a8.1 8.1 0 0 1 15.5 -2m.5 -4v4h-4', key: 'svg-0' }],
    ['path', { d: 'M20 13a8.1 8.1 0 0 1 -15.5 2m-.5 4v-4h4', key: 'svg-1' }],
]);

export default IconRefreshClockwise;
